import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { IconButton } from '@/components/ui';
import { FEATURES, useFeature } from '@/features/feature-flags';
import { useShortcutKeys } from '@/features/shortcuts';
import { cn } from '@/lib/utils';
import { inElectron } from '@/utils/capabilities';

import { sandboxTerminalPanelStore } from './sandbox-terminal-panel.store';

interface LocalTerminalToggleProps {
  className?: string;
}

/** Opens a shell on this machine in the app-wide bottom dock. Electron-only. */
export const LocalTerminalToggle = observer(function LocalTerminalToggle({
  className,
}: LocalTerminalToggleProps) {
  const hotkey = useShortcutKeys('terminal.toggle');
  const hasFeature = useFeature();
  if (!inElectron() || !hasFeature(FEATURES.LOCAL_TERMINAL)) return null;
  const isOpen = sandboxTerminalPanelStore.isLocalOpen;
  return (
    <IconButton
      size="sm"
      icon={Icons.terminal}
      tooltip="Terminal"
      tooltipOptions={{ side: 'bottom', hotkey }}
      aria-label={isOpen ? 'Close terminal' : 'Open terminal'}
      className={cn(isOpen && 'bg-surface-hover text-foreground', className)}
      onClick={() => sandboxTerminalPanelStore.toggleLocal()}
    />
  );
});
